import React from 'react';
import { FormField } from 'sos-common/js/commonTypes';
import { FieldName } from './Intyg.enums';
import { validateField } from '../Services/intyg.validation.service';
import { ValidationError, AppContext, IAppContext } from './Intyg.types';
import { CheckBoxGroup, CheckBox, SelectBox, TextInput } from 'sos-common/js';
import { IKeyValue } from './ansokan.types';
import _ from 'lodash';

export type FieldComponent = CheckBoxGroup | CheckBox | SelectBox | TextInput;
export class FormSectionBase<TProps, TState extends FormSectionBaseState> extends React.Component<TProps, TState> {
  static contextType = AppContext;
  //@ts-expect-error
  public context: IAppContext = this.context; // Simply to get typings on context
  protected fieldRefs: Map<string, React.RefObject<FieldComponent>> = new Map();
  protected emptyErrorsMap = new Map<string, ValidationError>();

  hasErrors(): boolean {
    return this.state?.errors?.size > 0;
  }

  getErrorMessage = (fieldName: string) => {
    return this.state.errors.get(fieldName)?.showMessage || this.context.submitButtonIsClicked
      ? this.state.errors.get(fieldName)?.errorMessage
      : null;
  };

  onChangeField = (
    field: FormField<any>,
    callback = this.context.onChangeFieldValue,
    errors = new Map(this.state.errors)
  ) => {
    const errorKey = validateField(field);
    let errorMessage = '';

    if (errorKey === '') {
      errors.delete(field.fieldName);
    } else {
      errorMessage = this.context.Translate(errorKey);
      errors.set(field.fieldName, { showMessage: true, errorMessage });
    }

    this.setState({ errors }, () => {
      callback(field);
    });
  };

  componentDidMount = () => {
    this.setInitialErrorsMap();
  };

  setInitialErrorsMap = (callback?: () => void) => {
    const errors = new Map<string, ValidationError>(this.state.errors);
    [...this.fieldRefs.values()].forEach((ref) => {
      const field = ref.current.state;
      const errorKey = validateField(field);

      if (errorKey !== '') {
        const errorMessage = this.context.Translate(errorKey);
        errors.set(field.fieldName, { showMessage: false, errorMessage });
      }
    });
    this.setState({ errors }, () => {
      if (callback) {
        callback();
      }
    });
  };

  getCheckboxGroupValue = (fieldNames: string[]) => {
    const checkedArr = [];
    fieldNames.forEach((fieldName) => {
      const isChecked = this.context.model[fieldName] as boolean | undefined | null;
      if (isChecked === true) {
        checkedArr.push(fieldName);
      }
    });
    return checkedArr;
  };

  getErrorSiblingClass = (field: FieldName, allOtherFields: FieldName[]) => {
    let numOfErrors = 0;
    allOtherFields.push(field);
    allOtherFields.forEach((fieldName) => {
      if (this.getErrorMessage(fieldName)) numOfErrors++;
    });
    if (numOfErrors === allOtherFields.length) return '';

    return this.getErrorMessage(field) ? 'error-sibling' : '';
  };

  findProperty = (name: string, fallbackTranslateVal?: string): string => {
    const needle: IKeyValue[] = _.filter(this.context.editableAreas, _.matches({ key: name }));
    if (needle && needle[0]?.value) {
      return needle[0]?.value;
    } else if (fallbackTranslateVal) {
      return this.context.Translate(fallbackTranslateVal);
    }
    return '';
  };
}

export interface FormSectionBaseState {
  errors: Map<string, ValidationError>;
}
